// @ts-nocheck
let isNavigationBlockerSkipped = false;

if (typeof window !== "undefined") {
    // Registered at import time, in capture phase, so it runs before NavigationBlocker's beforeunload prompt.
    window.addEventListener(
        "beforeunload",
        event => {
            if (isNavigationBlockerSkipped) {
                event.stopImmediatePropagation();
            }
        },
        true,
    );
}

/**
 * Call right before an intentional hard navigation or reload that NavigationBlocker's unsaved-changes prompt must never interrupt.
 * Also silences any other `beforeunload` listener for the rest of the page's life.
 */
const skipNavigationBlocker = () => {
    isNavigationBlockerSkipped = true;
};

export default skipNavigationBlocker;
